<template>
    <section id="team">
    <span class="square"></span>
    <h2>
      A <span>Maicá Escola de Música</span> tem professores especializados a sua
      disposição
    </h2>
    <div class="employees">
      <div class="employee">
        <img src="img/prof_violao.jpg" alt="Willian fagundes" />
        <p class="employee-name">Willian Fagundes</p>
        <p class="employee-role">Violão</p>
      </div>
      <div class="employee">
        <img src="img/prof.baixo.jpg" alt="Esperanza Spalding" />
        <p class="employee-name">Esperanza Spalding</p>
        <p class="employee-role">Baixo</p>
      </div>
      <div class="employee">
        <img src="img/prof.canto.jpg" alt="Marcelo Silva" />
        <p class="employee-name">Marcelo silva</p>
        <p class="employee-role">Canto</p>
      </div>
      <div class="employee">
        <img src="img/prof.piano.jpg" alt="Carlos Bernardo" />
        <p class="employee-name">Carlos Bernardo</p>
        <p class="employee-role">Piano</p>
      </div>
    </div>
  </section>
</template>
<script>
export default {
    name:'Colaboradores'
}
</script>
